// Premade "Predict Winner" categories.
// They use exactly the discipline / category / dance values stored by the results uploader
// (e.g. Latin | Solo Adult | Samba, Hip Hop | Solo Hip Hop Junior I), which is how the winner
// of each category is looked up in the uploaded results afterwards.

export const PREDICTION_DISCIPLINES = ['Latin', 'Contemporary', 'Hip Hop', 'Commercial'];
export const PREDICTION_AGES = ['Juvenile I', 'Juvenile II', 'Junior I', 'Junior II', 'Youth', 'Adult'];
export const LATIN_DANCES = ['Samba', 'ChaChaCha', 'Rumba', 'Pasodoble', 'Jive'];

/** Category string as saved on uploaded results. */
export const resultCategoryName = (discipline, age) =>
  discipline === 'Latin' ? `Solo ${age}` : `Solo ${discipline} ${age}`;

export const buildPredictionCategory = (discipline, age, dance = null) => {
  const danceValue = discipline === 'Latin' ? dance : null;
  return {
    id: [discipline, age, danceValue].filter(Boolean).join('_').replace(/\s+/g, '').toLowerCase(),
    label: [discipline, age, danceValue].filter(Boolean).join(' · '),
    discipline,
    category: resultCategoryName(discipline, age),
    ageCategory: age,
    dance: danceValue,
    startlist: [],
    winner: null
  };
};

/** Disciplines offered by a homepage card ("Latin - Solo", ...). Falls back to all of them. */
export const disciplinesForCard = (competition) => {
  const offered = PREDICTION_DISCIPLINES.filter((d) =>
    (competition.categories || []).some((c) => c.toLowerCase() === `${d} - solo`.toLowerCase())
  );
  return offered.length ? offered : PREDICTION_DISCIPLINES;
};

export const sortCategories = (cats) => {
  const di = (c) => PREDICTION_DISCIPLINES.indexOf(c.discipline);
  const ai = (c) => PREDICTION_AGES.indexOf(c.ageCategory);
  const li = (c) => LATIN_DANCES.indexOf(c.dance);
  return [...cats].sort((a, b) => di(a) - di(b) || ai(a) - ai(b) || li(a) - li(b));
};
